export default __webpack_public_path__ + "static/media/blue-arrow-circle.ccd156d5.svg";